import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-ingrid-button',
  templateUrl: './ingrid-button.component.html',
  styleUrls: ['./ingrid-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IngridButtonComponent {
  @Input() public disabled: boolean;
  @Input() public progress: boolean;
  @Input() public showMenuToggle: boolean;
  @Output() public clicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() public menuClicked: EventEmitter<any> = new EventEmitter<any>();

  public clickHandler(event: any): void {
    if (!this.disabled) this.clicked.emit(event);
  }

  public menuClickHandler(event: any): void {
    if (!this.disabled) this.menuClicked.emit(event);
  }
}
